package overlays

import org.koin.dsl.module

fun overlayKoinModule() = module {
    single { AlertOverlayStore() }
    single { TickerOverlayStore() }
    single { SplashOverlayStore() }
    single { ConfirmationOverlayStore() }
}